import * as React from "react";
import * as download from "downloadjs";
import {
  getFlightMarkersState,
  getSiteState,
  IStoreState,
} from "../../redux/rootReducer";
import { logCSVDownloaded } from "../../redux/modules/metrics/reducer";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import Button from "../Generics/Button";
import { createPlacedOnlyCsvInWgs } from "../../redux/computables/csvFile/csvFile";

const CsvWgsDownloadButton = () => {
  const csvFile: string = useAppSelector((state: IStoreState) =>
    createPlacedOnlyCsvInWgs(getFlightMarkersState(state), getSiteState(state)),
  );
  const dispatch = useAppDispatch();

  return (
    <Button
      stretched
      type="primary"
      label="CSV (WGS84)"
      icon={<img src="icon-download.svg" />}
      onClick={() => {
        dispatch(logCSVDownloaded());
        download(csvFile, "Flight_Markers_WGS84.csv", "text/csv");
      }}
    />
  );
};

export default CsvWgsDownloadButton;
